import { cliSimpleGit } from '../../../cli-simple-git.js';

export async function readGitBlobLines(repoCwd: string, pathInRepo: string): Promise<string[] | null> {
  try {
    const rel = pathInRepo.replace(/\\/g, '/');
    const raw = await cliSimpleGit(repoCwd).show([`HEAD:${rel}`]);
    return String(raw).split(/\r?\n/);
  } catch {
    return null;
  }
}
